import api from "./baseApi";
import endpoints from "./endpoints";

// ----------------------------
// Get schedules (index)
// ----------------------------
export const getSchedules = async ({ page = 1, perPage = 10, ...filters } = {}) => {
  try {
    const res = await api.get(endpoints.deviceSchedule.base, {
      params: { page, perPage, ...filters },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch schedules";

    throw new Error(message);
  }
};

// ----------------------------
// Create schedule (single OR bulk)
// ----------------------------
export const createSchedules = async (payload) => {
  try {
    /**
     * payload supports:
     * 
     * SINGLE:
     * { deviceId, action, datetime }
     * 
     * BULK:
     * { schedules: [{ deviceId, action, datetime }] }
     */
    const res = await api.post(endpoints.deviceSchedule.base, payload);

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to create schedules";

    throw new Error(message);
  }
};

// ----------------------------
// Delete schedule
// ----------------------------
export const deleteSchedule = async (id) => {
  try {
    const res = await api.delete(endpoints.deviceSchedule.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete schedule";

    throw new Error(message);
  }
};